var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateSolnBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_245_1",
    "data-name": "Component 245 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7707",
    "data-name": "Rectangle 7707",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15228",
    "data-name": "Group 15228",
    transform: "translate(-80.368 -137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11544",
    "data-name": "Group 11544",
    transform: "translate(-138.132 -1604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16171",
    "data-name": "Path 16171",
    d: "M9.1,14.067h.71a1.42,1.42,0,0,0,1.42-1.42V3.42A1.42,1.42,0,0,0,9.808,2H3.42A1.42,1.42,0,0,0,2,3.42v.71",
    transform: "translate(225.404 1743)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11543",
    "data-name": "Group 11543",
    transform: "translate(223.5 1748.904)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5690",
    "data-name": "Rectangle 5690",
    width: 9.228,
    height: 11.673,
    rx: 2,
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11542",
    "data-name": "Group 11542",
    transform: "translate(2.484 3.904)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1026",
    "data-name": "Line 1026",
    y2: 4.259,
    transform: "translate(2.129 0)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1027",
    "data-name": "Line 1027",
    x1: 4.259,
    transform: "translate(0 2.129)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateSolnBlue);
export default __webpack_public_path__ + "static/media/CreateSolnBlue.28b5ea445acc4eb3dc1a15b22fbc6718.svg";
export { ForwardRef as ReactComponent };